// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.NlqConfiguration.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import { observer } from 'mobx-react';
import { observe } from 'mobx';
import action from './Izenda.NLQSettingsAction';

import Button from 'share/components/controls/Izenda.Button';
import Alert from 'share/components/controls/Izenda.Alert';
import Prediction from '../MachineLearning/Izenda.Prediction';
import NLQSettings from './Izenda.NLQSettings';
import SearchMode from '../SearchMode/Izenda.SearchMode';
import LicenseCheckerConstants from 'logic/data/Izenda.LicenseCheckerConstants';
import NLQConfiguration from 'logic/models/Izenda.NLQConfiguration';
import uiState from 'logic/Izenda.UiState.js';
const ActionHeader = observer(function ActionHeader(props) {
  const {
    alertDetails,
    canSaveNLQSettings,
    localization
  } = props;
  return (
    <div className='izenda-Wrapper-header'>
      <div className='izenda-Alert-container'>
        <Alert type={alertDetails.alertType} onAutoHide={props.onAutoHide}>
          {alertDetails.message}
        </Alert>
      </div>
      <div className='pull-right'>
        <Button
          onClick={props.onSave}
          label={localization.getText('COMMON_LABEL_SAVE')}
          className='btn btn-default u_marginRight'
          disabled={!canSaveNLQSettings}
        />
        <Button onClick={props.onCancel} label={localization.getText('COMMON_LABEL_CANCEL')} />
      </div>
    </div>
  );
});

@connect(action)
export default class NlqConfiguration extends Component {

  constructor(props) {
    super(props);
    const getAllConnectionString = props.store.getAllConnectionString();
    props.store.nlqConfigurationModel = new NLQConfiguration(getAllConnectionString);
    this.state = {
      connectionId: ''
    };
    this.disposeObserveTenantID = observe(uiState, 'tenantId', () => {
      if (uiState.silentUpdate) return;
      const getAllConnectionString = props.store.getAllConnectionString();
      props.store.nlqConfigurationModel = new NLQConfiguration(getAllConnectionString);
      this.state = {
        connectionId: ''
      };
      });
    
  }

  componentDidMount() {
    const { store, loader } = this.props;
    loader.startLoading();
    store.init();
    this.props.store.getpredictionServerDetails().finally(loader.endLoading.bind(loader));
    this.props.store.getMLDBsettings();
    this.props.store.model.changeDBConnectionShow(false);

  }

  componentWillUnmount() {
    this.props.resetAlert();
  }

  testServerConfiguration(ipAdd) {
    const { loader } = this.props;
    loader.startLoading();
    this.props.store.checkPredictionServerStatus(ipAdd).then((data) => {
      this.props.store.model.predictionServerStatus = JSON.parse(data);
      let result = JSON.parse(data);
      if (result.success) {
        this.props.store.model.dbConectionActive = false;
        this.props.store.model.predictionServerSuccess = true;
      }
      this.props.store.alertDetails.set({
        success: result.success,
        message: result.messages[0]
      });
    }).catch(() => {
      this.props.store.alertDetails.set({
        message: 'Error while connecting to the Machine Learning Api'
      });
    })
      .finally(loader.endLoading.bind(loader));

  }

  testDBConfiguration(connectionString, ipAdd) {
    const { loader } = this.props;
    loader.startLoading();
    this.props.store.checkMLDBStatus(connectionString, ipAdd).then((data) => {
      this.props.store.model.mlDBConnectionStatus = JSON.parse(data);
      let result = JSON.parse(data);
      this.props.store.alertDetails.set({
        success: result.success,
        message: result.messages[0]
      });
      if (result.success) {
        this.props.store.model.dbServerSuccess = false;
      }
    }).catch((error) => {
      this.props.store.alertDetails.set({
        message: 'Error while connecting to the Database'
      });
      console.log(error);
    })
      .finally(loader.endLoading.bind(loader));
  }

  connectionIdInfo = (connectionId, searchMode) => {
    this.setState({
      connectionId: connectionId,
      searchMode: searchMode
    });
  }

  searchModeIsConfigure = (isConfigureDisable) => {
    this.setState({
      isConfigureDisable: isConfigureDisable
    });
  }

  render() {
    const props = this.props;
    const { connectionId, searchMode, isConfigureDisable } = this.state;
    const { store, localization, authorization } = props;
    const { alertDetails } = store;
    
    return (
      <div className='u_paddingAll'>
        <ActionHeader
          onSave={props.saveConfig}
          onCancel={props.cancelChangeConfig}
          onAutoHide={props.resetAlert}
          localization={localization}
          alertDetails={alertDetails}
          canSaveNLQSettings={store.canSaveNLQSettings && (authorization.checkLicense(LicenseCheckerConstants.LICENSE_KEY.Nlq))}
        />
        <div className='izenda-Wrapper-content u_paddingAll'>
          <div>
            <Prediction
              store={this.props.store}
              onclickmlserver={() => this.testServerConfiguration(store.model.mlServerIp)}
            />
            {
              (authorization.checkLicense(LicenseCheckerConstants.LICENSE_KEY.Nlq)) ?
                <NLQSettings
                  {...this.props}
                  connectionIdInfo={this.connectionIdInfo.bind(this)}
                  searchModeIsConfigure={this.searchModeIsConfigure.bind(this)}
                  store={this.props.store} /> : null
            }{
            this.props.store.nlqConfigurationModel.nlqSearchModeVisibility && <SearchMode
              {...this.props}
              connectionId={connectionId}
              searchMode={searchMode}
              isConfigureDisable={isConfigureDisable}
              store={this.props.store}
            /> }
           
          </div>
          <div>

          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Settings/SystemConfiguration/NlqConfiguration/Izenda.NlqConfiguration.js